import React from 'react';
import {
  Box,
  VStack,
  FormControl,
  FormLabel,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  Switch,
  Text,
  useColorModeValue,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  HStack,
} from '@chakra-ui/react';
import { useAI } from '../../../contexts/AIContext';

const AIPreferences: React.FC = () => {
  const { preferences, updatePreferences } = useAI();
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  return (
    <Box
      p={4}
      bg={bgColor}
      borderRadius="lg"
      border="1px solid"
      borderColor={borderColor}
    >
      <VStack spacing={6} align="stretch">
        {/* <FormControl>
          <FormLabel>Model</FormLabel>
          <Select
            value={preferences.model_preference}
            onChange={(e) =>
              updatePreferences({ model_preference: e.target.value as 'gpt-4o-mini' | 'gpt-3.5-turbo' })
            }
          >
            <option value="gpt-4o-mini">gpt-4o-mini (More capable, slower)</option>
            <option value="gpt-3.5-turbo">GPT-3.5 Turbo (Faster, less expensive)</option>
          </Select>
        </FormControl> */}

        <FormControl>
          <FormLabel>Temperature (Creativity)</FormLabel>
          <HStack spacing={4}>
            <Slider
              value={preferences.temperature * 100}
              onChange={(value) => updatePreferences({ temperature: value / 100 })}
              min={0}
              max={100}
              step={1}
              flex={1}
            >
              <SliderTrack>
                <SliderFilledTrack />
              </SliderTrack>
              <SliderThumb />
            </Slider>
            <NumberInput
              value={Math.round(preferences.temperature * 100)}
              onChange={(_, value) => updatePreferences({ temperature: value / 100 })}
              min={0}
              max={100}
              step={1}
              maxW="70px"
            >
              <NumberInputField />
              <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
              </NumberInputStepper>
            </NumberInput>
          </HStack>
          <Text fontSize="sm" color="gray.500" mt={1}>
            Lower values make responses more focused and deterministic, higher values make them more creative and varied
          </Text>
        </FormControl>

        <FormControl>
          <FormLabel>Maximum Context Entries</FormLabel>
          <NumberInput
            value={preferences.max_context_entries}
            onChange={(_, value) => updatePreferences({ max_context_entries: value })}
            min={1}
            max={10}
          >
            <NumberInputField />
            <NumberInputStepper>
              <NumberIncrementStepper />
              <NumberDecrementStepper />
            </NumberInputStepper>
          </NumberInput>
          <Text fontSize="sm" color="gray.500" mt={1}>
            Number of relevant journal entries to include as context
          </Text>
        </FormControl>

        <FormControl display="flex" alignItems="center">
          <FormLabel mb={0}>Include Mood Analysis</FormLabel>
          <Switch
            isChecked={preferences.include_mood_analysis}
            onChange={(e) =>
              updatePreferences({ include_mood_analysis: e.target.checked })
            }
          />
        </FormControl>

        <FormControl display="flex" alignItems="center">
          <FormLabel mb={0}>Include Location Context</FormLabel>
          <Switch
            isChecked={preferences.include_location_context}
            onChange={(e) =>
              updatePreferences({ include_location_context: e.target.checked })
            }
          />
        </FormControl>

        <FormControl display="flex" alignItems="center">
          <FormLabel mb={0}>Include Weather Context</FormLabel>
          <Switch
            isChecked={preferences.include_weather_context}
            onChange={(e) =>
              updatePreferences({ include_weather_context: e.target.checked })
            }
          />
        </FormControl>
      </VStack>
    </Box>
  );
};

export default AIPreferences; 